import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApolloAuthClient } from '@brainpool/apollo-connect';
import App from './app/app';

const apiUrl = `${import.meta.env.VITE_API_URL}/api`;
const clerkKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY!;

const context = {
  restApiUrl: apiUrl,
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <BrowserRouter>
      <ApolloAuthClient clerkKey={clerkKey} apiUrl={apiUrl} context={context}>
        <App />
      </ApolloAuthClient>
    </BrowserRouter>
  </StrictMode>
);
